import { LocaleKey } from 'helpers/languages/translations';
import { IVisibleKeyword } from 'types';

export const KEYWORDS_COLUMNS: { id: keyof IVisibleKeyword; name: LocaleKey; banner: boolean; search: boolean }[] = [
    { id: 'name', name: 'keyword.column.keyword', banner: true, search: true },
    { id: 'useage', name: 'keyword.column.useage', banner: true, search: true },
    { id: 'keyword_type', name: 'keyword.column.type', banner: true, search: true },
    { id: 'language', name: 'keyword.column.language', banner: true, search: true },
    { id: 'tags', name: 'keyword.column.lists', banner: true, search: true },
    { id: 'alcohol', name: 'keyword.column.alcohol', banner: true, search: true },
    { id: 'master', name: 'keyword.column.master', banner: true, search: true },
    { id: 'priority', name: 'keyword.column.criticality', banner: true, search: true },
    { id: 'for_int_scorecard', name: 'keyword.column.intScorecard', banner: false, search: true },
];

export const EMPTY_KEYWORD: IVisibleKeyword = {
    name: '',
    keyword_type: '',
    language: 'fr',
    master: 1,
    priority: 1,
    for_int_scorecard: false,
    for_search: true,
    tags: [],
};

export const EMPTY_PARTIAL_KEYWORD: IVisibleKeyword = {
    name: '',
    keyword_type: '',
    language: 'fr',
    priority: 1,
    master: 1,
    for_int_scorecard: false,
    for_search: true,
    tags: [],
};

export const FILTER_ALL_KEY = 'globalFilterAll';
